var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79398 17.0049C6.6759 19.1369 3.07655 19.8429 1 17.711C3.76873 14.8453 1 13.461 3.07655 11.3844C3.44117 10.9783 3.88479 10.6507 4.38028 10.4218C4.87578 10.1929 5.41275 10.0674 5.95838 10.0531C6.50402 10.0387 7.04684 10.1357 7.5537 10.3383C8.06055 10.5408 8.52078 10.8446 8.90626 11.231C9.29174 11.6174 9.59438 12.0784 9.79567 12.5857C9.99697 13.0931 10.0927 13.6362 10.077 14.1817C10.0613 14.7273 9.93453 15.264 9.70441 15.7589C9.47429 16.2539 9.14566 16.6967 8.7386 17.0603L8.79398 17.0049Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1939 1.80465C17.9254 1.53787 17.6051 1.32899 17.2527 1.19088C16.9003 1.05278 16.5233 0.9884 16.145 1.00171C15.767 1.01199 15.3951 1.09959 15.0523 1.25911C14.7094 1.41863 14.4029 1.6467 14.1516 1.92924L6.70367 10.2354C7.50234 10.3936 8.23251 10.7949 8.79407 11.3845C9.29913 11.8875 9.66623 12.512 9.86003 13.198L18.0693 5.84699C18.3502 5.59725 18.5773 5.29294 18.7367 4.95259C18.8962 4.61225 18.9847 4.243 18.9968 3.86735C19.0121 3.48679 18.9486 3.10719 18.8105 2.75227C18.6723 2.39735 18.4624 2.07475 18.1939 1.80465V1.80465Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlterIcon);
export default __webpack_public_path__ + "static/media/alterIcon.d8c2e31026b8eb350906e6537e49c0d0.svg";
export { ForwardRef as ReactComponent };